import { useState, useEffect } from 'react'
import ReactPaginate from 'react-paginate'
import { IPostNode } from '../types/postsListing'

import { pagination, active, heading } from './PaginatedContent.module.css'
import BlogPostPreviewGrid from '../components/blog-post-preview-grid'

function PaginatedContent({
  title,
  name,
  posts,
}: {
  title: string
  name?: string
  posts: IPostNode[]
}) {
  const perPage = 12
  const [offset, setOffset] = useState(0)
  const [dataPerPage, setDataPerPage] = useState<IPostNode[]>([])
  const [pageCount, setPageCount] = useState(0)

  const getData = () => {
    const slice = posts.slice(offset, offset + perPage)
    setDataPerPage(slice)
    setPageCount(Math.ceil(posts.length / perPage))
  }

  const handlePageClick = (selectedItem: { selected: number }) => {
    const newOffset = (selectedItem.selected * perPage) % posts.length
    setOffset(newOffset)
  }

  useEffect(() => {
    getData()
  }, [offset])
  return (
    <>
      <h1 className={heading}>{name || title}</h1>
      <BlogPostPreviewGrid nodes={dataPerPage} />
      <ReactPaginate
        previousLabel="Prev"
        nextLabel="Next"
        breakLabel="..."
        breakClassName="break-me"
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={pagination}
        activeClassName={active}
      />
    </>
  )
}

PaginatedContent.defaultProps = {
  name: undefined,
}

export default PaginatedContent
